// Shared public editorial content. Keep browser rendering and static HTML on this same source.
// Publication dates below are the original dates, not the date of translation.
const ASSET_ROOT = '/img/instagram-materials';

const RU_MATERIALS = {
  'ai-tools-weekly': {
    slug: 'ai-tools-weekly',
    kicker: 'Новости noesa',
    title: 'Что попробовать в AI на этой неделе',
    description:
      'Собрали короткий выпуск: пять рабочих prompt-маркеров, языковая практика с Claude, понятное сравнение ChatGPT и Claude, несколько бытовых сценариев и небольшой апдейт про noesa.',
    readingTime: '6 минут',
    dateLabel: '15 мая 2026',
    heroImage: `${ASSET_ROOT}/ai-weekly-secret-codes.png`,
    heroAlt: 'Пять английских prompt-команд на стеклянных карточках вокруг абстрактного AI-символа',
    productBlock: {
      id: 'noesa',
      eyebrow: 'Новый продукт',
      title: 'noesa: персональная операционная система для управления своей жизнью',
      tocTitle: 'Что такое noesa',
      body: [
        'Мы делаем noesa как персональную операционную систему для жизни: место, где мысли, решения, планы, дневник и разговоры с ИИ не расползаются по разным чатам и заметкам.',
        'У продукта уже есть удобный сайт, дневник, чат, аналитика, доступ к современным моделям ИИ и Telegram-бот для быстрых записей. Можно начать с одной мысли, а потом вернуться к ней в нормальном контексте.',
        'Следующий большой шаг - мобильное приложение. Хотим, чтобы noesa была рядом в ежедневных ритуалах: записать идею, разобрать день, сохранить вывод, быстро спросить ИИ и не потерять важное.',
      ],
      features: [
        'удобный сайт',
        'последние модели ИИ',
        'Telegram-бот',
        'приложение в разработке',
      ],
      note:
        'Главная идея noesa: личная информация должна постепенно складываться в систему, которая помогает лучше понимать себя и принимать решения, а не просто храниться мертвым архивом.',
    },
    sections: [
      {
        id: 'secret-codes',
        eyebrow: 'Промпты',
        title: '5 коротких маркеров для сильного ответа',
        iconName: 'Sparkles',
        image: `${ASSET_ROOT}/ai-weekly-secret-codes.png`,
        imageAlt: 'Английские команды 5Why, /sources, /reverse, TLDR и /debate',
        body: [
          'Частая ошибка - открыть чат, написать слишком общий вопрос и ждать точного ответа. Эти маркеры помогают сразу задать нужный режим: докопаться до причины, проверить факты, разобрать риск или сжать длинный текст.',
          'Это не скрытые команды платформы. Скорее короткие договоренности внутри запроса. Их удобно держать под рукой и дописывать к обычным промптам, когда нужен не просто ответ, а конкретный тип мышления.',
        ],
        commands: [
          {
            code: '5Why',
            text: 'Добавьте в конец запроса, если нужно дойти до причины, а не остановиться на первом объяснении.',
          },
          {
            code: '/sources',
            text: 'Попросите пройтись по спорным утверждениям и показать, что стоит проверить отдельно.',
          },
          {
            code: '/reverse',
            text: 'Начните с провала и разберите путь назад: какие решения могли к нему привести.',
          },
          {
            code: 'TLDR',
            text: 'Используйте для длинных текстов, когда нужна короткая версия без потери главной мысли.',
          },
          {
            code: '/debate',
            text: 'Попросите две позиции поспорить друг с другом. Полезно перед решением, где есть сильные аргументы с обеих сторон.',
          },
        ],
        note:
          'Если выбрать один прием для старта, берите 5Why. Он быстро показывает, где проблема описана слишком поверхностно.',
      },
      {
        id: 'language-tutor',
        eyebrow: 'Языки',
        title: 'Claude как языковой партнер',
        iconName: 'Languages',
        image: `${ASSET_ROOT}/ai-weekly-language-tutor.png`,
        imageAlt: 'Рабочий стол с ноутбуком и карточками языковой практики',
        body: [
          'Claude можно настроить как спокойного языкового партнера: он ведет диалог, исправляет ошибки в контексте, объясняет коротко и подстраивает сложность под ваш уровень.',
          'Это не заменяет живого преподавателя полностью, зато закрывает ежедневную практику. Особенно хорошо работают реальные сцены: заказать еду, написать письмо, пройти собеседование, обсудить поездку или разобрать вашу фразу.',
        ],
        steps: [
          'Создайте отдельный проект или чат с названием "Language Tutor".',
          'В инструкции попросите исправлять ошибки мягко, объяснять коротко и всегда задавать следующий вопрос.',
          'Напишите язык, уровень и цель: например, "испанский, A2, хочу увереннее говорить в поездке".',
          'Каждый день просите одно короткое задание: диалог, перевод, мини-текст или разбор вашей фразы.',
        ],
        note:
          'Главное - приносить конкретную ситуацию. Тогда вы тренируете не абстрактные фразы, а язык, который действительно может пригодиться.',
      },
      {
        id: 'tool-choice',
        eyebrow: 'Инструменты',
        title: 'ChatGPT или Claude: выбирайте под задачу',
        iconName: 'Lightbulb',
        image: `${ASSET_ROOT}/ai-weekly-tool-comparison.png`,
        imageAlt: 'Инфографика ChatGPT vs Claude с логотипами и типовыми задачами',
        body: [
          'Не обязательно выбирать один инструмент навсегда. Удобнее думать так: какая работа сейчас передо мной и какой режим нужен - быстрый поиск, картинка, анализ данных, длинный текст, редактура или код.',
          'ChatGPT часто быстрее раскрывается в ресерче, идеях, изображениях и работе с данными. Claude обычно сильнее в длинных текстах, аккуратной редактуре, коде и задачах, где важен спокойный человеческий тон.',
        ],
        comparison: [
          {
            title: 'Когда чаще открывать ChatGPT',
            items: ['быстрый ресерч', 'идеи и варианты', 'изображения', 'анализ данных', 'эксперименты с промптами'],
          },
          {
            title: 'Когда чаще открывать Claude',
            items: ['длинные тексты', 'редактура', 'код и сборка', 'проекты', 'тексты с естественным звучанием'],
          },
        ],
        note:
          'Хорошая привычка - перед запросом назвать задачу. Не "сделай хорошо", а "сравни варианты", "найди риски", "сожми", "отредактируй" или "разбери код".',
      },
      {
        id: 'parking',
        eyebrow: 'Бытовой кейс',
        title: 'Сфотографировать правила и получить короткий ответ',
        iconName: 'ParkingCircle',
        image: `${ASSET_ROOT}/ai-weekly-parking-signs.png`,
        imageAlt: 'Телефон распознает сложные парковочные знаки и показывает короткий ответ',
        body: [
          'Хороший пример мультимодального AI - парковочные знаки. Перед вами несколько табличек, исключения, дни недели, часы и мелкий шрифт. Вместо долгого разбора можно сфотографировать все сразу и спросить: "Сегодня среда, 16:00. Можно здесь парковаться? Ответь одной строкой".',
          'Та же логика работает с инструкциями, расписаниями, этикетками, меню, правилами тарифа и любыми ситуациями, где информации слишком много, а нужен простой вывод.',
        ],
        note:
          'Для важных решений проверяйте оригинал. AI может ошибаться, но как первый разбор визуальной путаницы это экономит много внимания.',
      },
      {
        id: 'human-writing',
        eyebrow: 'Текст',
        title: 'Как убрать из AI-текста искусственный блеск',
        iconName: 'PenLine',
        image: `${ASSET_ROOT}/ai-weekly-human-writing.png`,
        imageAlt: 'Механический текст превращается в живые заметки на бумаге',
        body: [
          'AI-текст часто выдает себя не ошибками, а чрезмерной гладкостью: много общих слов, одинаковый ритм, безопасные формулировки и ощущение, что автор старается понравиться всем сразу.',
          'Лечится это не магией, а редакторскими ограничениями. Перед генерацией задайте тон: короче, конкретнее, без канцелярита, без рекламных вводных, с вашим словарем и правом на неровную человеческую интонацию.',
        ],
        steps: [
          'Попросите переписать текст так, будто его пишет конкретный человек, а не отдел маркетинга.',
          'Запретите типовые слова AI-стиля: "углубиться", "использовать потенциал", "в быстро меняющемся мире", "важно отметить".',
          'Добавьте 2-3 ваших реальных фрагмента как пример тона.',
          'После первого ответа попросите второй проход: "сделай проще, суше, человечнее".',
        ],
        note:
          'Хороший текст не обязан быть идеально гладким. Часто именно небольшая неровность делает его живым.',
      },
      {
        id: 'textbook',
        eyebrow: 'Контент',
        title: 'AI-фраза в учебнике: смешно только на первый взгляд',
        iconName: 'FileText',
        image: `${ASSET_ROOT}/ai-weekly-textbook.png`,
        imageAlt: 'Открытый учебник с выделенным подозрительным AI-комментарием',
        body: [
          'По сети гуляет фото страницы учебника, где, похоже, в печать попала фраза из ответа чат-бота: что-то в духе "если хотите, я могу объяснить дальше". Сначала это выглядит как шутка. Потом вспоминаешь, что по таким материалам кто-то учится.',
          'Урок здесь простой: AI уже участвует в создании контента. Это нормально. Ненормально - выпускать текст без человека, который проверит факты, тон, структуру и следы черновика.',
        ],
        note:
          'AI ускоряет черновик. Ответственность за финальный материал все равно остается на человеке.',
      },
    ],
  },
  'free-ai-tools': {
    slug: 'free-ai-tools',
    kicker: 'AI-инструменты',
    title: '3 сайта, где можно попробовать сильные AI-инструменты без лишних подписок',
    description:
      'Arena, Pinokio и Design Arena закрывают разные сценарии: сравнить топовые модели, запустить AI-модели и инструменты локально, проверить креативные модели на реальных результатах. Разбираем, где польза, где ограничения и как не перепутать бесплатный доступ с безлимитом.',
    readingTime: '7 минут',
    dateLabel: '17 мая 2026',
    heroImage: `${ASSET_ROOT}/ai-free-tools-hero.png`,
    heroAlt: 'Три панели с AI-ареной, локальным AI-хабом Pinokio и Design Arena',
    sections: [
      {
        id: 'arena-ai',
        eyebrow: 'Модели',
        title: 'arena.ai: сравнить модели до того, как платить за подписки',
        iconName: 'Sparkles',
        image: `${ASSET_ROOT}/ai-free-tools-arena-interface.png`,
        imageAlt: 'Интерфейс Text Arena с рейтингом AI-моделей',
        imageKind: 'screenshot',
        body: [
          'Arena полезна не как еще один чат, а как место для быстрых сравнений. Вы задаете запрос, смотрите ответы разных моделей, голосуете за лучший вариант и видите, какие модели чаще выигрывают у живых пользователей.',
          'На момент проверки текстовый leaderboard Arena показывал сотни моделей и миллионы голосов. В карточках моделей видны организация, рейтинг, контекст, цена и лицензия. Это удобно, когда хочется выбрать инструмент под задачу, а не просто поверить очередному громкому анонсу.',
          'Важная оговорка: состав моделей и лимиты меняются. Поэтому точные названия доступных моделей лучше перепроверять прямо в интерфейсе. И не вставляйте туда приватные данные: в политике Arena отдельно сказано, что разговоры могут передаваться сторонним AI-провайдерам.',
        ],
        steps: [
          'Возьмите один реальный prompt из своей работы, но без личных данных.',
          'Запустите сравнение и выберите ответ, который реально лучше решает задачу.',
          'Посмотрите leaderboard и цену модели, если планируете использовать ее регулярно.',
          'Сохраните удачную формулировку prompt в noesa, чтобы не искать ее заново.',
        ],
        note:
          'Arena хороша для разведки: быстро понять, какие модели сильны именно в вашем типе задач. Для конфиденциальной работы лучше использовать сервисы с понятными настройками приватности или локальный запуск.',
        links: [
          { label: 'arena.ai', href: 'https://arena.ai/' },
          { label: 'Text leaderboard', href: 'https://arena.ai/leaderboard/text' },
          { label: 'Privacy', href: 'https://arena.ai/privacy' },
        ],
      },
      {
        id: 'pinokio',
        eyebrow: 'Локально',
        title: 'Pinokio: превратить компьютер в локальную AI-лабораторию',
        iconName: 'BookOpen',
        image: `${ASSET_ROOT}/ai-free-tools-pinokio-interface.png`,
        imageAlt: 'Интерфейс Pinokio с каталогом локальных AI-инструментов',
        imageKind: 'screenshot',
        body: [
          'Pinokio - это не облачный доступ ко всем платным моделям. Его смысл другой: он помогает ставить и запускать AI-модели, локальные инструменты и готовые пайплайны на вашем компьютере. На витрине есть сценарии для изображений, видео, аудио, текста и вспомогательных утилит.',
          'Для энтузиаста это снимает самую скучную часть локального AI: зависимости, установку, запуск, папки, команды. Вместо ручной возни вы пробуете модели и инструменты как готовые сценарии: нажали, поставили, запустили, проверили результат.',
          'Цена здесь не подписка, а ресурсы вашего компьютера. Тяжелые модели занимают место, требуют памяти и часто хотят хорошую видеокарту. Перед установкой стоит смотреть требования и понимать, откуда приходит скрипт.',
        ],
        steps: [
          'Начните с одной понятной задачи: локальная генерация изображений, TTS или видео-утилита.',
          'Проверьте требования к GPU, RAM и свободному месту на диске.',
          'Ставьте инструменты по одному, чтобы видеть, что именно потребляет ресурсы.',
          'Не запускайте непонятные скрипты из сомнительных источников.',
        ],
        note:
          'Pinokio лучше воспринимать как удобный пульт установки для локального AI. Он не отменяет ограничения железа, но резко снижает порог входа в open-source инструменты.',
        links: [
          { label: 'Pinokio beta', href: 'https://beta.pinokio.co/' },
          { label: 'Pinokio app', href: 'https://pinokio.computer/' },
        ],
      },
      {
        id: 'designarena',
        eyebrow: 'Креатив',
        title: 'Design Arena: смотреть на результат, а не на имя модели',
        iconName: 'PenLine',
        image: `${ASSET_ROOT}/ai-free-tools-designarena-interface.png`,
        imageAlt: 'Интерфейс Design Arena с категориями для творческих AI-задач',
        imageKind: 'screenshot',
        body: [
          'Design Arena полезна, когда вас интересует не только текстовый интеллект модели, а ее вкус в креативных задачах. На сайте есть категории вроде website generation, UI, logo, image, video, voice, 3D, mobile app и game dev.',
          'Работает это как битва двух результатов вслепую: разные модели получают один prompt, вы выбираете лучший вариант, а имя модели раскрывается уже после голосования. Так меньше шансов выбрать бренд вместо качества.',
          'Для дизайнеров, продактов и AI-энтузиастов это хороший тренажер насмотренности. Видно, где модели делают красивую картинку, а где ломают структуру, логику интерфейса, композицию или детали.',
        ],
        comparison: [
          {
            title: 'Что удобно проверять',
            items: ['лендинги и UI', 'логотипы и SVG', 'изображения и видео', '3D-объекты', 'игровые прототипы'],
          },
          {
            title: 'На что смотреть',
            items: ['структура', 'читаемость', 'детали', 'соответствие prompt', 'можно ли использовать результат дальше'],
          },
        ],
        note:
          'Design Arena особенно полезна, если вы выбираете модель для визуальной работы. Смотрите не на демо, а на output: он быстро показывает настоящие сильные и слабые стороны инструмента.',
        links: [
          { label: 'Design Arena', href: 'https://www.designarena.ai/' },
          { label: 'Методология', href: 'https://www.designarena.ai/about' },
        ],
      },
      {
        id: 'how-to-use',
        eyebrow: 'Схема',
        title: 'Для чего нужен каждый из этих сайтов',
        iconName: 'Lightbulb',
        image: `${ASSET_ROOT}/ai-free-tools-hero.png`,
        imageAlt: 'Три AI-инструмента для сравнения моделей, локального запуска и креативных задач',
        body: [
          'У каждого сервиса своя роль. Arena отвечает на вопрос "какая модель лучше решает мой prompt". Pinokio - "какие AI-модели и инструменты я могу запустить у себя". Design Arena - "какая модель лучше делает креативный результат".',
          'Бесплатный доступ почти всегда имеет условия: лимиты, очереди, меняющийся список моделей, требования к железу или вопросы приватности. Это нормально. Просто стоит заранее понимать, какую цену вы платите: временем, данными, ресурсами компьютера или ограничениями сервиса.',
        ],
        comparison: [
          {
            title: 'Arena',
            items: ['быстро сравнить LLM', 'посмотреть рейтинги', 'не вставлять личные данные'],
          },
          {
            title: 'Pinokio',
            items: ['запускать AI локально', 'пробовать open-source', 'следить за ресурсами компьютера'],
          },
          {
            title: 'Design Arena',
            items: ['оценивать визуальный output', 'сравнивать креативные модели', 'прокачивать насмотренность'],
          },
        ],
        note:
          'Практичный подход: возьмите один и тот же prompt, прогоните его в разных местах и сохраните лучшие результаты в дневник. Через пару недель у вас будет не список ссылок, а собственная карта рабочих AI-инструментов.',
      },
    ],
  },
};

// English translations retain the original articles' scope and publication context.
const EN_TRANSLATIONS = {
  'ai-tools-weekly': {
    kicker: 'noesa news',
    title: 'What to try in AI this week',
    description: 'A short edition with five useful prompt markers, language practice with Claude, a straightforward ChatGPT and Claude comparison, a few everyday use cases, and a small update on noesa.',
    readingTime: '6 min read',
    dateLabel: '15 May 2026',
    heroAlt: 'Five English prompt commands on glass cards around an abstract AI symbol',
    productBlock: {
      eyebrow: 'New product',
      title: 'noesa: a personal operating system for managing your life',
      tocTitle: 'What is noesa?',
      body: [
        'We are building noesa as a personal operating system for life: a place where thoughts, decisions, plans, a diary, and AI conversations do not end up scattered across different chats and notes.',
        'The product already has an easy-to-use website, a diary, chat, analytics, access to modern AI models, and a Telegram bot for quick notes. You can start with one thought and return to it later with its context intact.',
        'The next big step is a mobile app. We want noesa to be part of daily routines: capturing an idea, reflecting on the day, saving a conclusion, asking AI a quick question, and keeping track of what matters.',
      ],
      features: ['easy-to-use website', 'latest AI models', 'Telegram bot', 'app in development'],
      note: 'The central idea of noesa is that personal information should gradually form a system that helps you understand yourself and make decisions, rather than simply sitting in an inactive archive.',
    },
    sections: [
      {
        eyebrow: 'Prompts',
        title: '5 short markers for a stronger answer',
        imageAlt: 'The English commands 5Why, /sources, /reverse, TLDR, and /debate',
        body: [
          'A common mistake is to open a chat, ask an overly broad question, and expect a precise answer. These markers help you set the mode immediately: find a root cause, check facts, examine a risk, or shorten a long text.',
          'These are not hidden platform commands. They are brief conventions within a request. Keep them handy and add them to ordinary prompts when you need a particular kind of thinking, not just an answer.',
        ],
        commands: [
          { code: '5Why', text: 'Add this to the end of a request when you need to reach the cause rather than stop at the first explanation.' },
          { code: '/sources', text: 'Ask the model to review disputed claims and show what needs to be checked separately.' },
          { code: '/reverse', text: 'Start with a failure and work backwards: which decisions could have led to it?' },
          { code: 'TLDR', text: 'Use this for long texts when you need a short version without losing the main point.' },
          { code: '/debate', text: 'Ask two positions to argue with each other. This is useful before a decision with strong arguments on both sides.' },
        ],
        note: 'If you pick just one technique to start with, try 5Why. It quickly reveals where a problem has been described too superficially.',
      },
      {
        eyebrow: 'Languages',
        title: 'Claude as a language partner',
        imageAlt: 'A desk with a laptop and language-practice cards',
        body: [
          'You can set up Claude as a patient language partner: it keeps a conversation going, corrects mistakes in context, gives brief explanations, and adjusts the difficulty to your level.',
          'It does not fully replace a human teacher, but it can support daily practice. Real situations work particularly well: ordering food, writing an email, interviewing for a job, discussing a trip, or reviewing a phrase you wrote.',
        ],
        steps: [
          'Create a separate project or chat named "Language Tutor".',
          'In the instructions, ask it to correct mistakes gently, explain briefly, and always ask the next question.',
          'State your language, level, and goal, for example: "Spanish, A2, I want to speak more confidently when travelling".',
          'Each day, ask for one short task: a dialogue, a translation, a mini text, or feedback on a phrase you wrote.',
        ],
        note: 'The key is to bring a specific situation. That way you practise language you may actually need, not abstract phrases.',
      },
      {
        eyebrow: 'Tools',
        title: 'ChatGPT or Claude: choose for the task',
        imageAlt: 'A ChatGPT vs Claude infographic with logos and typical tasks',
        body: [
          'You do not have to choose one tool forever. A more useful question is: what work is in front of me, and what do I need — a quick search, an image, data analysis, a long text, editing, or code?',
          'ChatGPT often shows its strengths more quickly in research, ideas, images, and working with data. Claude is usually stronger in long texts, careful editing, code, and tasks where a calm, human tone matters.',
        ],
        comparison: [
          { title: 'When to reach for ChatGPT more often', items: ['quick research', 'ideas and alternatives', 'images', 'data analysis', 'prompt experiments'] },
          { title: 'When to reach for Claude more often', items: ['long texts', 'editing', 'code and building', 'projects', 'natural-sounding writing'] },
        ],
        note: 'A useful habit is to name the task before making a request. Not "make it good", but "compare the options", "find risks", "shorten this", "edit this", or "review the code".',
      },
      {
        eyebrow: 'Everyday use',
        title: 'Photograph the rules and get a short answer',
        imageAlt: 'A phone interprets complicated parking signs and displays a short answer',
        body: [
          'Parking signs are a good example of multimodal AI. You face several signs, exceptions, days of the week, hours, and small print. Instead of a lengthy first pass, you can photograph them together and ask: "It is Wednesday, 4 pm. Can I park here? Answer in one line".',
          'The same approach works for instructions, timetables, labels, menus, plan conditions, and other situations with too much information and a need for a simple conclusion.',
        ],
        note: 'For important decisions, check the original. AI can make mistakes, but as an initial reading of visual clutter it can save a great deal of attention.',
      },
      {
        eyebrow: 'Writing',
        title: 'How to remove the artificial polish from AI writing',
        imageAlt: 'Mechanical writing turns into lively handwritten notes',
        body: [
          'AI writing often gives itself away through excessive smoothness rather than mistakes: too many general words, a uniform rhythm, cautious phrasing, and a sense that the author is trying to please everyone at once.',
          'The remedy is not magic, but editorial constraints. Before generating, set the tone: shorter, more specific, no bureaucratic language or promotional introductions, with your vocabulary and room for an uneven, human voice.',
        ],
        steps: [
          'Ask for a rewrite as if a specific person were writing it, not a marketing department.',
          'Ban typical AI-style phrases: "delve into", "harness the potential", "in a rapidly changing world", and "it is important to note".',
          'Add two or three real excerpts of your own writing as examples of the tone.',
          'After the first answer, ask for another pass: "make it simpler, plainer, and more human".',
        ],
        note: 'Good writing does not need to be perfectly smooth. A little unevenness is often what makes it feel alive.',
      },
      {
        eyebrow: 'Content',
        title: 'An AI phrase in a textbook: only funny at first glance',
        imageAlt: 'An open textbook with a suspicious AI comment highlighted',
        body: [
          'A photograph circulating online appears to show a textbook page where a phrase from a chatbot response made it into print: something like "if you would like, I can explain further". At first it looks like a joke. Then you remember that someone is learning from this material.',
          'The lesson is simple: AI is already part of content creation. That is fine. Publishing without a person checking the facts, tone, structure, and leftover draft text is not.',
        ],
        note: 'AI speeds up the draft. A person remains responsible for the final material.',
      },
    ],
  },
  'free-ai-tools': {
    kicker: 'AI tools',
    title: '3 websites for trying powerful AI tools without extra subscriptions',
    description: 'Arena, Pinokio, and Design Arena cover different tasks: comparing leading models, running AI models and tools locally, and checking creative models against actual results. We explain the benefits and limitations, and why free access is not the same as unlimited use.',
    readingTime: '7 min read',
    dateLabel: '17 May 2026',
    heroAlt: 'Three panels showing an AI arena, the local AI hub Pinokio, and Design Arena',
    sections: [
      {
        eyebrow: 'Models',
        title: 'arena.ai: compare models before paying for subscriptions',
        imageAlt: 'The Text Arena interface with an AI model leaderboard',
        body: [
          'Arena is useful not as another chat, but as a place for quick comparisons. You submit a request, see answers from different models, vote for the better one, and discover which models real users choose more often.',
          'At the time of checking, the Arena text leaderboard showed hundreds of models and millions of votes. Model cards display the organisation, ranking, context, price, and licence. This is useful when choosing a tool for a task rather than simply trusting another big announcement.',
          'An important caveat: model availability and limits change. Check the exact models currently offered in the interface. Do not paste private data: Arena states in its privacy policy that conversations may be shared with third-party AI providers.',
        ],
        steps: [
          'Take one real prompt from your work, with no personal data.',
          'Run a comparison and choose the answer that actually solves the task better.',
          'Check the leaderboard and model price if you plan to use it regularly.',
          'Save the successful prompt wording in noesa so you do not have to find it again.',
        ],
        note: 'Arena is good for exploration: quickly finding which models are strong at your kind of task. For confidential work, use services with clear privacy settings or run models locally.',
        links: [
          { label: 'arena.ai', href: 'https://arena.ai/' },
          { label: 'Text leaderboard', href: 'https://arena.ai/leaderboard/text' },
          { label: 'Privacy', href: 'https://arena.ai/privacy' },
        ],
      },
      {
        eyebrow: 'Local tools',
        title: 'Pinokio: turn your computer into a local AI lab',
        imageAlt: 'The Pinokio interface with a catalogue of local AI tools',
        body: [
          'Pinokio is not cloud access to every paid model. Its purpose is different: it helps you install and run AI models, local tools, and ready-made pipelines on your computer. Its catalogue includes workflows for images, video, audio, text, and supporting utilities.',
          'For an enthusiast, it takes away the most tedious parts of local AI: dependencies, installation, launch commands, and folders. Instead of manual setup, you try models and tools as ready-made workflows: click, install, run, and check the result.',
          'The cost here is not a subscription, but your computer’s resources. Heavy models take up storage, require memory, and often need a capable graphics card. Before installing, check the requirements and understand where the script comes from.',
        ],
        steps: [
          'Start with one clear task: local image generation, text-to-speech, or a video utility.',
          'Check GPU, RAM, and free disk-space requirements.',
          'Install tools one at a time so you can see what consumes resources.',
          'Do not run unfamiliar scripts from questionable sources.',
        ],
        note: 'Think of Pinokio as a convenient installer for local AI. It does not remove hardware limits, but makes open-source tools much easier to get started with.',
        links: [
          { label: 'Pinokio beta', href: 'https://beta.pinokio.co/' },
          { label: 'Pinokio app', href: 'https://pinokio.computer/' },
        ],
      },
      {
        eyebrow: 'Creative work',
        title: 'Design Arena: judge the result, not the model name',
        imageAlt: 'The Design Arena interface with categories for creative AI tasks',
        body: [
          'Design Arena is useful when you care about a model’s creative taste, not just its ability with text. The site has categories such as website generation, UI, logo, image, video, voice, 3D, mobile app, and game development.',
          'It works as a blind comparison of two results: different models receive the same prompt, you choose the better result, and the model name is revealed after voting. This makes it less likely that you choose a brand instead of quality.',
          'For designers, product people, and AI enthusiasts, it is useful practice in visual judgement. You can see where models produce an attractive image and where they break structure, interface logic, composition, or details.',
        ],
        comparison: [
          { title: 'What you can check', items: ['landing pages and UI', 'logos and SVG', 'images and video', '3D objects', 'game prototypes'] },
          { title: 'What to look for', items: ['structure', 'readability', 'details', 'fit to the prompt', 'whether the result is usable afterwards'] },
        ],
        note: 'Design Arena is particularly useful when choosing a model for visual work. Look at the output rather than a demo: it quickly reveals a tool’s real strengths and weaknesses.',
        links: [
          { label: 'Design Arena', href: 'https://www.designarena.ai/' },
          { label: 'Methodology', href: 'https://www.designarena.ai/about' },
        ],
      },
      {
        eyebrow: 'Overview',
        title: 'What each of these websites is for',
        imageAlt: 'Three AI tools for model comparisons, local use, and creative tasks',
        body: [
          'Each service has a role. Arena answers "which model handles my prompt better?" Pinokio answers "which AI models and tools can I run on my own computer?" Design Arena answers "which model produces a better creative result?"',
          'Free access almost always comes with conditions: limits, queues, a changing model list, hardware requirements, or privacy considerations. That is normal. Just understand what you are paying with: time, data, computer resources, or service restrictions.',
        ],
        comparison: [
          { title: 'Arena', items: ['quickly compare LLMs', 'check rankings', 'keep personal data out'] },
          { title: 'Pinokio', items: ['run AI locally', 'try open-source tools', 'watch your computer’s resources'] },
          { title: 'Design Arena', items: ['evaluate visual output', 'compare creative models', 'develop visual judgement'] },
        ],
        note: 'A practical approach: take the same prompt, try it in different places, and save the best results in your diary. After a couple of weeks, you will have your own map of useful AI tools, not just a list of links.',
      },
    ],
  },
};

const NEWS_UI = {
  ru: {
    title: 'Статьи про искусственный интеллект от noesa',
    description: 'Интересные статьи про искусственный интеллект от команды noesa: практические разборы, AI-инструменты, промпты и понятные объяснения без лишней сложности.',
    h1: 'Интересные статьи про искусственный интеллект',
    lead: 'Команда noesa собирает практическую экспертизу по AI и делится ей простым языком: какие инструменты стоит попробовать, как меняется рынок и как использовать искусственный интеллект с пользой в работе и жизни.',
    kicker: 'Статьи noesa', latest: 'Читать свежую статью', all: 'Все статьи',
    panelTitle: 'Разборы от команды noesa',
    panelBody: 'Мы отбираем темы, проверяем источники и упаковываем материалы так, чтобы в AI было легче ориентироваться без технического перегруза.',
    listLabel: 'Список статей noesa', article: 'Статья', read: 'Читать статью', back: 'Назад',
    home: 'На главную noesa', account: 'аккаунт', myDiary: 'Мой дневник', login: 'Войти', register: 'Создать аккаунт',
    adding: 'Добавляем...', addingMaterial: 'Добавляем материал в дневник...', add: 'Добавить себе в дневник', addShort: 'Добавить в дневник',
    afterRegister: 'После регистрации мы вернем вас сюда и сохраним материал в дневник.',
    failedAdd: 'Не получилось добавить материал. Попробуйте еще раз.', toc: 'Внутри материала',
    saveKicker: 'Сохранить выпуск', saveTitle: 'Добавьте эту новость в дневник noesa',
    saveBody: 'Так выпуск останется в личном пространстве: можно вернуться позже, дописать свои выводы и связать его с другими наблюдениями.',
    openDiary: 'Открыть дневник', tryNoesa: 'Попробовать noesa', more: 'Подробнее', lifeOs: 'Личная операционная система',
    summary: 'Короткая выжимка', source: 'Источник', savedFrom: 'Сохранено из noesa',
    editorialAuthor: 'Редакция Noesa.ai', author: 'Автор', about: 'Кто мы', news: 'Публикации о Noesa', planner: 'ИИ-планировщик', pricing: 'Тарифы',
    notFoundTitle: 'Статья не найдена', notFoundBody: 'Этой статьи нет в нашем каталоге. Выберите материал на странице статей.',
  },
  en: {
    title: 'Artificial intelligence articles by noesa',
    description: 'AI articles from the noesa team: practical guides, tools, prompts, and straightforward explanations without unnecessary complexity.',
    h1: 'Articles about artificial intelligence',
    lead: 'The noesa team shares practical AI knowledge in plain language: which tools to try, how the market is changing, and how to put artificial intelligence to use in work and everyday life.',
    kicker: 'noesa articles', latest: 'Read the latest article', all: 'All articles',
    panelTitle: 'Guides from the noesa team',
    panelBody: 'We select topics, check sources, and present material that makes AI easier to navigate without technical overload.',
    listLabel: 'noesa article list', article: 'Article', read: 'Read article', back: 'Back',
    home: 'noesa home', account: 'account', myDiary: 'My diary', login: 'Sign in', register: 'Create account',
    adding: 'Adding...', addingMaterial: 'Adding the article to your diary...', add: 'Add to my diary', addShort: 'Add to diary',
    afterRegister: 'After registration, we will bring you back here and save the article to your diary.',
    failedAdd: 'We could not add the article. Please try again.', toc: 'In this article',
    saveKicker: 'Save this edition', saveTitle: 'Add this article to your noesa diary',
    saveBody: 'Keep this edition in your personal space: return later, add your conclusions, and connect it with other observations.',
    openDiary: 'Open diary', tryNoesa: 'Try noesa', more: 'Learn more', lifeOs: 'Personal life OS',
    summary: 'Quick summary', source: 'Source', savedFrom: 'Saved from noesa',
    editorialAuthor: 'Noesa.ai editorial team', author: 'Author', about: 'Who we are', news: 'Noesa in publications', planner: 'AI planner', pricing: 'Pricing',
    notFoundTitle: 'Article not found', notFoundBody: 'This article is not in our catalogue. Choose a guide from the articles page.',
  },
};

const NEWS_SLUGS = Object.freeze(Object.keys(RU_MATERIALS));
const PUBLICATION_DATES = { 'ai-tools-weekly': '2026-05-15', 'free-ai-tools': '2026-05-17' };
const EDITORIAL_ORGANIZATION = Object.freeze({
  '@type': 'Organization', '@id': 'https://noesa.ai/#organization', name: 'Noesa.ai', url: 'https://noesa.ai/',
});

function normalizeLanguage(lang) { return lang === 'en' ? 'en' : 'ru'; }

const MATERIALS_BY_LANGUAGE = { ru: {}, en: {} };
for (const slug of NEWS_SLUGS) {
  const original = RU_MATERIALS[slug];
  for (const language of ['ru', 'en']) {
    const translation = language === 'en' ? EN_TRANSLATIONS[slug] : null;
    MATERIALS_BY_LANGUAGE[language][slug] = {
      ...original,
      ...translation,
      sections: original.sections.map((section, index) => ({ ...section, ...translation?.sections[index] })),
      ...(original.productBlock ? { productBlock: { ...original.productBlock, ...translation?.productBlock } } : {}),
      language,
      datePublished: PUBLICATION_DATES[slug],
      author: EDITORIAL_ORGANIZATION,
      publisher: EDITORIAL_ORGANIZATION,
    };
  }
}

function getNewsArticle(slug, lang = 'ru') {
  if (!NEWS_SLUGS.includes(slug)) return undefined;
  return MATERIALS_BY_LANGUAGE[normalizeLanguage(lang)][slug];
}

function getNewsArticles(lang = 'ru') {
  return NEWS_SLUGS.map((slug) => getNewsArticle(slug, lang))
    .sort((a, b) => b.datePublished.localeCompare(a.datePublished));
}

function getNewsUi(lang = 'ru') { return NEWS_UI[normalizeLanguage(lang)]; }

module.exports = { NEWS_SLUGS, getNewsArticle, getNewsArticles, getNewsUi };
